<template>
  <NodeViewWrapper as="span" class="text-placeholder" :style="$props.selected ? { opacity: 0.8 } : {}" draggable="true" data-drag-handle>
    <PlaceholderVNode v-if="$props.extension?.options && placeholder" :node="$props.extension.options.slot({ placeholder, preview: true })"/>
  </NodeViewWrapper>
</template>

<script>
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3';
import PlaceholderVNode from "./PlaceholderVNode";

export default {
  name: "PlaceholderView",
  components: {NodeViewWrapper, PlaceholderVNode},
  props: nodeViewProps,
  computed: {
    placeholder() {
      return this.$props.extension?.options?.placeholders?.find(item => item.key === this.$props.node?.attrs?.key);
    }
  }
}
</script>

<style>
  .text-placeholder {
    cursor: grab !important;
  }
  .text-placeholder:active {
    opacity: 0.7;
    cursor: grabbing !important;
  }
</style>